"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.KEY_ROTATION_REQUIRED = exports.KEY_ALREADY_ROTATED = exports.ENCRYPTION_KEY_URL_MISMATCH = void 0;
var KEY_ROTATION_REQUIRED = 1400087;
exports.KEY_ROTATION_REQUIRED = KEY_ROTATION_REQUIRED;
var KEY_ALREADY_ROTATED = 1409004;
exports.KEY_ALREADY_ROTATED = KEY_ALREADY_ROTATED;
var ENCRYPTION_KEY_URL_MISMATCH = 1400049;
exports.ENCRYPTION_KEY_URL_MISMATCH = ENCRYPTION_KEY_URL_MISMATCH;
//# sourceMappingURL=constants.js.map
